<template>
    <div class="borderComercial">
        <div class="content">
            <div class="titulo">
                <b-row>
                    <b-col cols="12" md>
                        <div class="linea lineaIzquierda"></div>
                    </b-col>
                    <b-col cols="12" md="auto">
                        <p>border comercial</p>
                    </b-col>
                    <b-col cols>
                        <div class="linea lineaDerecha"></div>
                    </b-col>
                </b-row>
            </div>
            <div class="textBorderComercial">
                <div v-if="lang == 'eng'">
                    <h2>GROW WITHOUT BORDERS</h2>
                    <p>Improve your exposure towards the border market with our digital screens and fixed advertising, which are strategically located at the border crossings of the Tijuana - San Diego region and soon in Mexicali-Calexico.</p>
                    <a href="https://garitas.com.mx/" target="_blank" class="btn">Click here to see the waiting time at the checkpoints</a>
                </div>

                <div v-else-if="lang == 'esp'">
                    <h2>CRECE SIN FRONTERAS</h2>
                    <p>Mejora tu exposición frente al mercado fronterizo con nuestras pantallas electrónicas y publicidad fija, las cuales están estratégicamente ubicadas en los cruces fronterizos de la región Tijuana - San Diego y próximamente en Mexicali-Calexico.</p>
                    <a href="https://garitas.com.mx/" target="_blank" class="btn">Consulta aquí el tiempo de espera en garitas</a>
                </div>
            </div>
            <div class="numeros">
                <b-row>
                    <b-col cols="12" md="4">
                        <div class="numero">
                            <img src="../assets/img/icn_800.svg" alt="800">
                        </div>
                        <p v-if="lang == 'eng'">People cross per week</p>
                        <p v-else-if="lang == 'esp'">Personas cruzan a la semana</p>
                        <div class="diagonal"></div>
                    </b-col>
                    <b-col cols="12" md="4" class="numero800">
                        <div class="numero">
                            <img src="../assets/img/icn_300.svg" alt="800">
                        </div>
                        <p v-if="lang == 'eng'">Weekly impressions</p>
                        <p v-else-if="lang == 'esp'">Impresiones semanales</p>
                        <div class="diagonal"></div>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="numero">
                            <img src="../assets/img/icn_mx.svg" alt="mx">
                        </div>
                        <p v-if="lang == 'eng'">Dual market</p>
                        <p v-else-if="lang == 'esp'">Mercado dual</p>
                    </b-col>
                </b-row>
            </div>
            <div class="servicios">
                <b-row>
                    <b-col cols="12" md="4">
                        <div class="servicio">
                            <p v-if="lang == 'eng'">We implement campaigns in less than <span>72 hours</span></p>
                            <p v-else-if="lang == 'esp'">Implementamos tus campañas en menos de <span>72 horas</span></p>
                        </div>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="servicio servicioCentro">
                            <p v-if="lang == 'eng'"><span>3.4 million</span> potential monthly reaches.</p>
                            <p v-else-if="lang == 'esp'"><span>3.4 millones</span> de alcances potenciales mensuales.</p>
                        </div>
                    </b-col>
                    <b-col cols="12" md="4">
                        <div class="servicio">
                            <p v-if="lang == 'eng'">We strengthen your campaigns on the website and social networks</p>
                            <p v-else-if="lang == 'esp'">Fortalecemos tus campañas en pagina web y redes sociales.</p>
                        </div>
                    </b-col>
                </b-row>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapActions, mapMutations} from 'vuex'
    export default {
        computed:{
            ...mapState(['lang'])
        }
    }
</script>

<style scoped>
    .borderComercial{
        background-image: url('../assets/img/img_background.jpg');
        background-size: cover;
        background-position: left top;
        position: relative;
        text-align: center;
        padding-top: 100px;
    }
    .textBorderComercial p{
        margin: 10px auto 20px auto;
        max-width: 900px;
    }
    .btn{
        background-color: #33B4BA!important;
        border-radius: inherit!important;
        -webkit-box-shadow: 0px 5px 10px 0px rgba(173,225,227,1)!important;
        -moz-box-shadow: 0px 5px 10px 0px rgba(173,225,227,1)!important;
        box-shadow: 0px 5px 10px 0px rgba(173,225,227,1)!important;
        padding: 5px 30px!important;
        max-width: 100%!important;
        color: white!important;
    }
    .numeros{
        padding: 80px 0;
    }
    .numero {
        width: 85%;
        margin: 0 auto;
    }
    .numeros p{
        color: #606060;
        margin-top: 10px;
    }
    .numeros .diagonal{
        position: absolute;
        right: 0;
        height: 100%;
        width: 1px;
        background-color: rgba(56, 56, 56, 0.5);
        top: 0;
        transform: rotate(190deg);
    }
    .servicios{
        margin-top: 40px;
    }
    .servicio{
        text-align: center;
        background-color: #F7F7F7;
        -webkit-box-shadow: 0px 10px 30px 0px rgba(231,209,204,1);
        -moz-box-shadow: 0px 10px 30px 0px rgba(231,209,204,1);
        box-shadow: 0px 10px 30px 0px rgba(231,209,204,1);
        padding: 50px 30px;
        margin: 0 30px;
        height: 100%;
    }
    .servicio p span{
        color: #EF4E28!important;
        font-family: 'sailecBold';
        font-size: 13pt;
    }
    .servicioCentro{
        margin-top: -40px;
    }
    img{
        width: 100%;
    }

    
    @media screen and (max-width: 1180px){
        .servicio{
            margin-left: 0;
            margin-right: 0;
        }
    }
    @media screen and (max-width: 767px){
        .borderComercial{
            padding-top: 80px;
        }
        .servicios{
            margin-top: 0;
        }
        .servicio{
            height: auto;
        }
        .servicioCentro{
            margin: 20px 0;
        }
        .diagonal{
            display: none;
        }
        .numero800{
            margin: 50px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Border.vue